import { render, staticRenderFns } from "./_CustomExtensionRender.vue?vue&type=template&id=4104d644&scoped=true&"
import script from "./_CustomExtensionRender.vue?vue&type=script&lang=ts&"
export * from "./_CustomExtensionRender.vue?vue&type=script&lang=ts&"
import style0 from "./_CustomExtensionRender.vue?vue&type=style&index=0&id=4104d644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104d644",
  null
  
)

export default component.exports